import { gql } from '@apollo/client'

const GET_CLIENT_PACKAGES = gql`
  query GetClientPackages($first: Int!, $page: Int!) {
    clientPackages(first: $first, page: $page, orderBy: [
      {
        field: "package_id",
        order: DESC
      }
    ]) {
      data {
        package_id
        formatted_package_id
        summary_with_tax
        cancellationReason {
            name
        }
        order {
          tracking_url
          created_at
          summary_with_tax
          partner_division_id
          service {
              service_id
          }
          sizes {
            size_id
          }
        }
        public_status
        pick_up {
          contact {
            first_name
            last_name
            phone
            email
          }
          address {
            formatted_address
            zip_code
            city
            address
          }
          note
          partner_address_note
        }
        recipients {
          contact {
            first_name
            last_name
            phone
            email
          }
          address {
            formatted_address
            zip_code
            city
            address
          }
          cash_on_delivery
          note
          partner_address_note
        }
      }
      paginatorInfo {
        currentPage
        lastPage
        total
      }
    }
  }
`

export { GET_CLIENT_PACKAGES }
